// Vendor scripts
import 'bootstrap';
import 'bootstrap-icons-vue';
import 'aos';

// Vue
import './vue/vue.js';

// Custom scripts

import './scripts/accordion-anchors';
import './scripts/aos';
import './scripts/bazaarvoice-custom';
import './scripts/bs-custom';
import './scripts/carousel';
import './scripts/collapse-focus';
import './scripts/footnotes';
import './scripts/form-label';
import './scripts/hubspot-form';
import './scripts/meganav';
import './scripts/product-compare-button';
import './scripts/product-image-carousel';
import './scripts/search-form';
import './scripts/section-nav';
import './scripts/tabs';
import './scripts/video-modal';
import './scripts/product-detail-page';
import './scripts/hide-more';
import './scripts/cookie-banner';

window.acknowledgeCookieBanner = require('./scripts/cookie-banner').default;
